import React from 'react';
import { Link } from 'react-router-dom';

// Bilinmeyen URL'ler. Apache bu sayfayi 404.html olarak 404 statusuyle servis eder
// (public/.htaccess -> ErrorDocument), meta robots noindex src/seo/meta.js'ten gelir.
const NotFound = () => (
    <main className="leader-page">
        <section className="leader-hero">
            <div className="container text-center text-md-start">
                <h1 className="leader-hero-name">Page not found</h1>
                <p className="leader-hero-exp mb-0">
                    The page you are looking for does not exist or has been moved.
                </p>
            </div>
        </section>

        <section className="leader-body">
            <div className="container">
                <Link to="/" className="btn experienceSeeBtn px-4 py-2 leader-back-btn">
                    BACK TO HOME <i className="bi bi-arrow-up-right btn-icon ms-2"></i>
                </Link>
            </div>
        </section>
    </main>
);

export default NotFound;
